import * as React from 'react'
import { IPayment } from '@getgreenline/homi-shared'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { Body } from './Body'

interface Props {
  payment: IPayment
  inventoryLogs?: IInventoryLog[]
}

export class InventoryLogs extends React.Component<Props, {}> {
  render() {
    return (
      <div>
        <h5 className='text-muted'>Inventory logs</h5>
        <Body payment={this.props.payment} inventoryLogs={this.props.inventoryLogs} />
      </div>
    )
  }
}
